var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWwStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 57,
    viewBox: "0 0 77 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3049 56.0139V26.1965C30.3049 22.1826 27.0556 18.9332 23.0304 18.9332H15.3849C11.3711 18.9332 8.11047 22.1826 8.11047 26.1965V56.0252H30.3049V56.0139Z",
    fill: "white",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3645 56.0139V26.1965C69.3645 22.1826 66.1152 18.9332 62.0901 18.9332H54.4446C50.4307 18.9332 47.1701 22.1826 47.1701 26.1965V56.0252H69.3645V56.0139Z",
    fill: "white",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1442 56.014H1.61182",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.095 15.9875C23.0381 15.9875 26.2345 12.791 26.2345 8.84793C26.2345 4.90486 23.0381 1.70837 19.095 1.70837C15.1519 1.70837 11.9554 4.90486 11.9554 8.84793C11.9554 12.791 15.1519 15.9875 19.095 15.9875Z",
    fill: "#63C7C9",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8285 15.9875C61.7716 15.9875 64.9681 12.791 64.9681 8.84793C64.9681 4.90486 61.7716 1.70837 57.8285 1.70837C53.8855 1.70837 50.689 4.90486 50.689 8.84793C50.689 12.791 53.8855 15.9875 57.8285 15.9875Z",
    fill: "#63C7C9",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6721 36.4841C25.4591 38.0919 26.561 39.4074 27.5392 40.498C29.3381 42.4768 31.3731 44.2308 33.3295 45.9286C34.3864 46.8393 35.4433 47.75 36.4552 48.6944C37.1298 49.3128 37.8493 49.6276 38.5914 49.6276C39.3335 49.6276 40.098 49.3128 40.8064 48.6719C42.7627 46.9292 44.7078 45.1865 46.6417 43.4213C48.6655 41.5886 50.1608 39.9696 51.3639 38.3393C52.8143 36.3717 53.4327 34.2017 53.2078 31.8743C52.9717 29.4008 51.7462 27.5119 49.6661 26.41C45.9333 24.4312 41.5372 24.8135 38.5577 27.2983C36.2415 25.3869 33.352 24.7348 30.1589 25.4319C27.854 25.9378 26.1899 26.961 25.0769 28.5688C24.4697 29.457 24.2111 30.4014 24.0087 31.1547L23.9525 34.0218L24.0425 34.5615C24.1886 35.1574 24.3573 35.8208 24.6721 36.4841Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwStep1);
export default __webpack_public_path__ + "static/media/ww-step1.bc1e89fa.svg";
export { ForwardRef as ReactComponent };